import React from 'react';
import { Badge } from '../ui/badge';
import { AlertTriangle } from 'lucide-react';
import { resumenActivos } from './cvuUtils';

// "CVU activos: BI 1 · CMF 1" + aviso si hay CVUs activos en bancos sponsor anteriores.
export const CvuResumenActivos = ({ cvus, testid = 'cvu-resumen', compacto = false }) => {
  const grupos = resumenActivos(cvus);
  const anteriores = grupos.filter((g) => g.anterior);
  const texto = grupos.length ? grupos.map((g) => `${g.nombre} ${g.cantidad}`).join(' · ') : 'ninguno';
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      <span className={`text-slate-600 ${compacto ? 'text-xs' : 'text-sm'}`}>
        {!compacto && <span className="text-slate-400">CVU activos: </span>}
        <span className="font-medium text-slate-800" data-testid={`${testid}-texto`}>{texto}</span>
      </span>
      {anteriores.length > 0 && (
        <Badge className="text-[10px] px-1.5 py-0 bg-amber-100 text-amber-800 border border-amber-200 gap-1" data-testid={`${testid}-aviso-anterior`}
          title="Tiene CVUs activos en bancos sponsor que ya no se usan">
          <AlertTriangle size={11} />
          {compacto ? 'Sponsor anterior activo' : `Activo en banco anterior: ${anteriores.map((g) => g.nombre).join(', ')}`}
        </Badge>
      )}
    </div>
  );
};
